module.exports = __webpack_public_path__ + "img/pufayinhang.199192a2.png";